export const SPECIAL_OFFER_UI = {
  urgencyPrefix: '⚡',
  timePrefix: '🕒',
  detailToggleShow: '📋 View Details & Terms',
  detailToggleHide: '📋 Hide Details',
  includedHeading: "What's Included",
  termsHeading: 'Terms & Conditions',
  validUntilPrefix: 'Offer valid until',
  validUntilSuffix: 'Book now to secure your spot!',
  hotLabel: '🔥 HOT',
  secondaryFallbackCta: 'Learn More'
};

export const SPECIAL_OFFER_DECOR = {
  emojis: ['🎉', '✨', '🎊'],
  bubbles: [
    { className: 'top-8 left-8 w-16 h-16 delay-0' },
    { className: 'bottom-12 right-12 w-12 h-12 delay-700' },
    { className: 'top-1/3 right-8 w-8 h-8 delay-300' }
  ]
};

export const toOfferDisplayDate = (value) => {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return 'a limited time';
  }

  return parsed.toLocaleDateString('en-IN', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

export const getOfferTimeLeft = (validUntil) => {
  const validDate = new Date(validUntil);
  if (Number.isNaN(validDate.getTime())) {
    return 'Limited period';
  }

  const now = new Date();
  const timeDiff = validDate.getTime() - now.getTime();
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  if (daysLeft > 1) {
    return `${daysLeft} days left`;
  }

  if (daysLeft === 1) {
    return '1 day left';
  }

  return 'Expires soon';
};
